import flagPoland from '../images/flag-poland.png';
import flagUkraine from '../images/flag-ukraine.png';
import '../styles/AvatarCard.scss';

type AvatarCardProps = {
  item: { nftId: number; image: string; name: string; occupationName: string };
  onClick: (e: React.MouseEvent<HTMLElement>) => void;
};

const AvatarCard: React.FC<AvatarCardProps> = (props) => {
  const isFromPoland =
    props.item.name === 'Mr3ddi' || props.item.name === '0xWysocki';
  return (
    <div className="avatar-card">
      <div
        className={'avatar-card-body ' + (isFromPoland ? 'poland' : '')}
        onClick={props.onClick}
      >
        <div className="avatar-card-header"></div>
        <div className="avatar-img-holder">
          <img
            className="avatar-card-image"
            alt="Avatar"
            src={props.item.image}
          ></img>
          <img
            className="avatar-flag"
            src={isFromPoland ? flagPoland : flagUkraine}
            alt="flag"
          ></img>
        </div>
        <div className="bottom-container">
          <p className="avatar-card-title">{props.item.name}</p>
          <p className="avatar-card-description">{props.item.occupationName}</p>
        </div>
      </div>
    </div>
  );
};

export default AvatarCard;
